import React from 'react';
import { useSwiper } from '../hooks/useSwiper';
import { useTranslation } from 'react-i18next';

const BrandOne = ( { className } ) => {
  const swiperRef = useSwiper();
  // Brand logos data
  const brandLogos = [
    { id: 1, src: 'assets/img/brand/brand_1_1.svg', alt: 'Brand Logo 1' },
    { id: 2, src: 'assets/img/brand/brand_1_2.svg', alt: 'Brand Logo 2' },
    { id: 3, src: 'assets/img/brand/brand_1_3.svg', alt: 'Brand Logo 3' },
    { id: 4, src: 'assets/img/brand/brand_1_4.svg', alt: 'Brand Logo 4' },
    { id: 5, src: 'assets/img/brand/brand_1_5.svg', alt: 'Brand Logo 5' },
  ];

  const { t } = useTranslation();
  // Duplicate the array for continuous loop effect (2 times = 10 slides)
  const duplicatedBrands = [...brandLogos, ...brandLogos];

  return (
    <div className={`${className}`}>
      <div className="container ot-container">
        <div
          ref={swiperRef}
          className="swiper ot-react-slider"
          data-cue="slideInUp"
          id="brandSlider1"
          data-slider-options='{"breakpoints":{"0":{"slidesPerView":2},"576":{"slidesPerView":"2"},"768":{"slidesPerView":"3"},"992":{"slidesPerView":"4"},"1200":{"slidesPerView":"5"},"1400":{"slidesPerView":"5"}}}'
        >
          <div className="swiper-wrapper">
            {duplicatedBrands.map((brand, index) => (
              <div className="swiper-slide" key={`${brand.id}-${index}`}>
                <div className="brand-card">
                    <a target="_blank" href="https://themeforest.net/" rel="noopener noreferrer">
                    <img src={brand.src} alt={t(`sections.brandOne.brand_alt_${brand.id}`, brand.alt)} />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandOne;